class FeaturedQuotes extends HTMLElement {
  constructor() {
    super();
    this.InitSwiper();
  }
  InitSwiper() {
    let $swiper = this.querySelector('.swiper');
    var swiper = new Swiper($swiper, {
      slidesPerView: 1.4,
      spaceBetween: 30,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: $swiper.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          centeredSlides: false,
          initialSlide: 0,
          spaceBetween: 80
        }
      }
    });    
  }
}
customElements.define('featured-quotes', FeaturedQuotes);

class FeaturedReviews extends HTMLElement {
  constructor() {
    super();
    this.InitSwiper();
  }
  InitSwiper() {
    let $swiper = this.querySelector('.swiper');
    var swiper = new Swiper($swiper, {
      slidesPerView: 1.25,
      spaceBetween: 15,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: $swiper.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 2.25,
          centeredSlides: false,
          initialSlide: 0,
        },
        1440: {
          slidesPerView: 3.25,
          centeredSlides: false,
          initialSlide: 0,
        }
      }
    });    
  }
}
customElements.define('featured-reviews', FeaturedReviews);

class FeaturedBlogPostsSwiper extends HTMLElement {
  constructor() {
    super();
    this.InitSwiper();
  }
  InitSwiper() {
    let $swiper = this.querySelector('.swiper');
    var swiper = new Swiper($swiper, {
      slidesPerView: 1.15,
      spaceBetween: 10,
      loop: true,
      centeredSlides: true,
      autoHeight: true,
      pagination: {
        el: $swiper.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          centeredSlides: false,
          initialSlide: 0,
          spaceBetween: 15
        }
      }
    });    
  }
}
customElements.define('featured-blog-posts-swiper', FeaturedBlogPostsSwiper);

class BtnActionVideo extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => {
      let video_media_id = this.dataset.videoMediaId;
      let $thumb_video = document.querySelector(`[data-thumbnail-id="${video_media_id}"]`);
      $thumb_video.dispatchEvent(new CustomEvent('click', {bubbles: true}));

      let video_index = this.dataset.videoIndex - 1;
      window.mobileMediaCarousel.select(video_index);
    });
  }
}
customElements.define('btn-action-video', BtnActionVideo);

class FeaturedBoards extends HTMLElement {
  constructor() {
    super();
    this.InitSwiper();
  }
  InitSwiper() {
    let $swiper = this.querySelector('.swiper');
    var swiper = new Swiper($swiper, {
      slidesPerView: 1.4,
      centeredSlides: true,
      initialSlide: 1,
      pagination: {
        el: $swiper.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: 3,
          loop: false
        }
      }
    });    
  }
}
customElements.define('featured-boards', FeaturedBoards);

class SortByLabel extends HTMLElement {
  constructor() {
    super();
    let _this = this;
    document.addEventListener('products:loaded', (e) => {
      _this.querySelector('.current-sort').textContent = e.detail.sortby;
    });
  }
}
customElements.define('sort-by-label', SortByLabel);

const _UTILS = {
  async AddItemsToCart(items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    })
  },
  RefreshCart() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));    
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('ProductUpsells', () => ({
    settings: {},
    total_price: 0,
    total_compare_price: 0,
    saved_percent: 0,
    init() {
      this.InitSelf();
      this.InitWatchers();
      this.UpdateTotals();
    },
    InitSelf() {
      let am = this;
      let settings = JSON.parse(am.$el.dataset.settings);
      settings.product_list.forEach((product) => {
        product.selected = true;
      });

      let product = JSON.parse(am.$el.dataset.currentProduct);
      product.current = true;
      // add current product to list
      settings.product_list.unshift(product);
      am.settings = settings;
    },
    FormatMoney(cents) {
      return window.formatMoney(cents, window.theme.moneyFormat).replace('.00', '');
    },
    InitWatchers() {
      let am = this;
      am.$watch('settings.product_list', am.UpdateTotals.bind(am));
    },
    UpdateTotals() {
      let am = this;
      let selected_items = am.settings.product_list
        .filter((p) => p.selected || p.current);
      
      am.selected_items = selected_items;
      // console.log(selected_items);
      
      let total_price = selected_items
        .reduce((sum, p) => {
          return sum += p.variants[0].price;
        }, 0);

      let total_compare_price = selected_items
        .reduce((sum, p) => {
          return sum += p.variants[0].compare_at_price;
        }, 0);
      am.total_price = total_price;
      am.total_compare_price = total_compare_price; 
      am.saved_percent = Math.ceil(((total_compare_price - total_price) / total_compare_price) * 100);
    },
    async e_AddBundleToCart() {
      let am = this;
      let selected_items = am.settings.product_list
        .filter((p) => p.selected || p.current);

      let items_to_add = selected_items.map(item => {
        return {
          id: item.variants[0].id,
          quantity: 1
        };
      });
      await _UTILS.AddItemsToCart(items_to_add);
      _UTILS.RefreshCart();
    }
  }))
});